/**
 * API Configuration
 * 
 * Uses relative URLs by default so the same build works on any deployment slot.
 * Falls back to REACT_APP_BACKEND_URL if set (for local development).
 */

// Use relative URL in production, env var for local dev
const getApiBase = () => {
  // In production/staging, use relative URLs (same origin)
  if (process.env.NODE_ENV === 'production') {
    return '';
  }
  // In development, use the env var
  return process.env.REACT_APP_BACKEND_URL || '';
};

export const API_BASE = getApiBase();
export const API = `${API_BASE}/api`;

/**
 * TEMPORARY FEATURE DISABLES
 * Set to true to force-hide features regardless of tenant settings
 * TODO: Re-enable when ready for production
 */
export const DISABLED_FEATURES = {
  navigate_academy: true,    // Navigate Academy | Professional Qualifications
  regulatory_alerts: true,   // Regulatory Alerts
  // Add more features here as needed
};

export default API;
